/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';

/**
 *
 * @export
 * @interface WorkflowDataInput
 */
export interface WorkflowDataInput {
    /**
     *
     * @type {string}
     * @memberof WorkflowDataInput
     */
    workflowId?: string;
    /**
     *
     * @type {string}
     * @memberof WorkflowDataInput
     */
    key?: string | null;
    /**
     *
     * @type {string}
     * @memberof WorkflowDataInput
     */
    data?: string | null;
}

export function WorkflowDataInputFromJSON(json: any): WorkflowDataInput {
    return WorkflowDataInputFromJSONTyped(json, false);
}

export function WorkflowDataInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowDataInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'workflowId': !exists(json, 'workflowId') ? undefined : json['workflowId'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'data': !exists(json, 'data') ? undefined : json['data'],
    };
}

export function WorkflowDataInputToJSON(value?: WorkflowDataInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'workflowId': value.workflowId,
        'key': value.key,
        'data': value.data,
    };
}

